import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { BF2GetConfigBasedOutskirtBuilding } from "./BF2GetConfigBasedOutskirtBuilding";
export var BF2GetOutskirtBuildingWatertower = function (data, level, buildingState, isAccessible, buildingName) {
    var config = artConfigBuildings["Watertower" + level];
    return BF2GetConfigBasedOutskirtBuilding(config);
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2GetOutskirtBuildingWatertower.ts
// module id = 2171
// module chunks = 3